module.exports = __webpack_public_path__ + "static/media/controls.b2c5f117.svg";